// extracted by mini-css-extract-plugin
export var body = "c_d";
export var footer = "c_g";
export var header = "c_c";
export var network = "c_f";